import React from 'react';

export const SuggestionListItemServicesIcon = () => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      opacity="0.4"
      d="M7 4.66699C5.067 4.66699 3.5 6.234 3.5 8.16699C3.5 10.0831 5.03979 11.6396 6.9495 11.6666L5.19927 18.5476H10.1909L11.941 11.667H15.8799C16.4497 11.667 16.9116 11.2051 16.9116 10.6353V5.69865C16.9116 5.12888 16.4497 4.66699 15.8799 4.66699H7Z"
      fill="#60A3BD"
    />
    <path
      d="M22.1667 8.16699C22.1667 9.45566 21.122 10.5003 19.8334 10.5003H16.9167V5.83366H19.8334C21.122 5.83366 22.1667 6.87833 22.1667 8.16699ZM22.1667 8.16699H25.6667M3.5 8.16699C3.5 6.234 5.067 4.66699 7 4.66699H15.8799C16.4497 4.66699 16.9116 5.12888 16.9116 5.69865V10.6353C16.9116 11.2051 16.4497 11.667 15.8799 11.667H11.941L10.1909 18.5476H5.19927L6.94951 11.6666C5.03979 11.6396 3.5 10.0831 3.5 8.16699ZM3.50004 18.667H12.8334V23.3337H3.50004V18.667Z"
      stroke="#0D5263"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
